module.exports = __webpack_public_path__ + "img/logo-icoev.5814e409.png";